import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { SongType } from 'services/api/entities';
import { SongData } from 'services/store/distribution/types';
import { usePlayer } from './hooks';
import PlaybackButton from './components/PlaybackButton';
import {
  TrackSectionContainer,
  StyledTextContainer,
  StyledSongTitle,
  StyledSongSource,
} from './styled';

type PropsType = {
  song: SongData;
};

const TrackSection = ({ song }: PropsType) => {
  const { t } = useTranslation();

  const { isPlaying, play, pause } = usePlayer(song);
  const { songType, title } = song;

  const songSource = useMemo(() => {
    if (songType === SongType.USER_UPLOADED) {
      return t('distribution:tracklist:songs:source:userUploaded');
    }
    return t('distribution:tracklist:songs:source:createdUsingLoudly');
  }, [t, songType]);

  return (
    <TrackSectionContainer>
      <PlaybackButton isPlaying={isPlaying} play={play} pause={pause} />
      <StyledTextContainer>
        <StyledSongTitle>{title || '-'}</StyledSongTitle>
        <StyledSongSource>{songSource}</StyledSongSource>
      </StyledTextContainer>
    </TrackSectionContainer>
  );
};

export default TrackSection;
